const http = {
    STATUS: {
        OK: 200,
        CREATED: 201,
        NO_CONTENT: 204,
        PARTIAL_CONTENT: 206,
        UNAUTHORIZED: 401,
        PAYMENT_REQUIRED: 402,
        FORBIDDEN: 403,
        NOT_FOUND: 404,
        GONE: 410,
        PRECONDITION_FAILED: 412
    },

    /**
     * Sends a head request with Zeplin headers.
     * @param url
     * @param options additional fetch options
     */
    head(url: string, options: RequestInit = {}): Promise<Response> {
        const args = {
            headers: Zeplin.headers,
            method: "HEAD",
            ...options
        };

        return fetch(url, args);
    },

    /**
     * Sends a get request with Zeplin headers.
     * @param url
     * @param options additional fetch options
     */
    get(url: string, options: RequestInit = {}): Promise<Response> {
        return fetch(url, { headers: Zeplin.headers, ...options });
    },

    /**
     * Sends a post request with Zeplin headers.
     * @param url
     * @param body
     */
    post(url: string, body?: unknown, signal?: AbortSignal): Promise<Response> {
        const args = {
            headers: Zeplin.headers,
            method: "POST",
            signal
        };

        if (body) {
            Object.assign(args, { body: JSON.stringify(body) });
        }

        return fetch(url, args);
    },

    /**
     *  Sends a put request with Zeplin headers
     * @param url
     * @param body
     */
    put(url: RequestInfo, body?: unknown): Promise<Response> {
        const args = {
            headers: Zeplin.headers,
            method: "PUT"
        };

        if (body) {
            Object.assign(args, { body: JSON.stringify(body) });
        }

        return fetch(url, args);
    },

    /**
     * Sends a delete request with Zeplin headers
     * @param url
     * @param body
     */
    delete(url: RequestInfo, body?: unknown): Promise<Response> {
        const args = {
            headers: Zeplin.headers,
            method: "DELETE"
        };

        if (body) {
            Object.assign(args, { body: JSON.stringify(body) });
        }

        return fetch(url, args);
    }
};

export default http;
